export const emailRE = new RegExp(
  "[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,6}",
);
export const nameRE = /^[a-zA-Z]+(\s[a-zA-Z]+)*$/;

export const matchDollarAmountRE = new RegExp("^\\$?\\d+(\\.\\d+)?$");

export const validateBase64EncodingImage = /^data:image\/jpeg;base64,/;
